import { 
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut,
    updateProfile
  } from 'firebase/auth';
  import { 
    doc, 
    setDoc, 
    getDoc 
  } from 'firebase/firestore';
  import { auth,db } from './firebaseconfig';
  
  export const authService = {
    // Register new user
    register: async (email, password, displayName, role, additionalInfo = {}) => {
      try {
        // Create authentication user
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
  
        // Update profile with display name
        await updateProfile(user, { displayName });
  
        // Store additional user data in Firestore
        await setDoc(doc(db, 'users', user.uid), {
          email,
          displayName,
          role,
          createdAt: new Date().toISOString(),
          ...additionalInfo
        });
  
        // Store user info in localStorage
        localStorage.setItem('user', JSON.stringify({
          uid: user.uid,
          email: user.email,
          displayName,
          role
        }));
  
        return {
          user,
          userData: {
            email,
            displayName,
            role,
            ...additionalInfo
          }
        };
      } catch (error) {
        console.error("Registration error:", error);
        throw error;
      }
    },
  
    // Login user
    login: async (email, password) => {
      try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        const userDoc = await getDoc(doc(db, 'users', userCredential.user.uid));
        const userData = userDoc.data();
  
        // Store user info in localStorage
        localStorage.setItem('user', JSON.stringify({
          uid: userCredential.user.uid,
          email: userCredential.user.email,
          displayName: userData.displayName,
          role: userData.role
        }));
  
        if (userData.role === 'admin') {
          localStorage.setItem('isAdmin', 'true');
        }
  
        return {
          user: userCredential.user,
          userData
        };
      } catch (error) {
        console.error("Login error:", error);
        throw error;
      }
    },
  
    // Logout user
    logout: async () => {
      try {
        await signOut(auth);
        localStorage.removeItem('user');
        localStorage.removeItem('isAdmin');
      } catch (error) {
        console.error("Logout error:", error);
        throw error;
      }
    },
  
    // Get current user role
    getCurrentUserRole: async (uid) => {
      try {
        const userDoc = await getDoc(doc(db, 'users', uid));
        return userDoc.data()?.role;
      } catch (error) {
        console.error("Get role error:", error);
        throw error;
      }
    }
  };